// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { defaultBillingAddressStyles } from "@insite/content-library/Widgets/AccountSettings/DefaultBillingAddress";
import Edit from "@insite/mobius/Icons/Edit";
import { createLinkIconStyles } from "@pacific/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

defaultBillingAddressStyles.editLink = {
    ...createLinkIconStyles(Edit, {
        css: css`
            margin-top: 3px;
        `,
    }),
};

defaultBillingAddressStyles.headingText = {
    ...defaultBillingAddressStyles.headingText,
    css: css`
        margin-bottom: 5px;
        margin-right: 10px;
    `,
};


defaultBillingAddressStyles.headingGridItem = {
    ...defaultBillingAddressStyles.headingGridItem,
    css: css`
        flex-wrap: wrap;
    `,
};

defaultBillingAddressStyles.customerSelectorModalCancelButton = { variant: "tertiary" };

defaultBillingAddressStyles.customerSelectorModal = { sizeVariant: "large" };
